import { bindActionCreators } from 'redux';
import { connect } from 'react-redux'
import {fetchWorkHistories, clearWorkHistoriesStatus} from '../actions/attendstatus'
import {fetchFilterDatas} from '../actions/filter'
import AttendStatus from '../components/AttendStatus'

const mapStateToProps = state => {
  const { workhistorystatus } = state
  const { filter } = state
  const {
    isFetching,
    lastUpdated,
    items,
    totalRows,
    // startDate
  } = workhistorystatus || {
    isFetching: true,
    items: []
  }

  const {
    filterDatas,
  } = filter || {
    filterDatas: []
  }

  return {
    items,
    filterDatas,
    isFetching,
    lastUpdated,
    totalRows,
    // startDate,
  }
}

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      getWorkHistories: fetchWorkHistories,
      getFilterDatas: fetchFilterDatas,
      clearWorkHistoriesStatus,
    },
    dispatch,
  );

export default connect(mapStateToProps, mapDispatchToProps)(AttendStatus)
